// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const React = require(`react`);
const Layout = require(`./src/layouts/Layout`).default;

exports.wrapPageElement = ({ element, props }) => {
  if (props.location.pathname !== `/contact/`) {
    return <Layout {...props}>{element}</Layout>;
  }
};
